import React from "react";
import { motion } from "framer-motion";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { HelpCircle } from "lucide-react";
import { useSite } from "@/context/SiteContext";

export default function FAQ() {
  const { faqs } = useSite();
  if (!faqs?.length) return null;

  return (
    <section data-testid="faq-section" className="section-padding bg-white">
      <div className="dc-container">
        <div className="grid lg:grid-cols-12 gap-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="lg:col-span-5"
          >
            <span className="text-xs font-semibold uppercase tracking-[0.25em] text-dc-primary">Dúvidas frequentes</span>
            <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-dc-text mt-3 mb-5">
              Tudo que você precisa saber antes de começar
            </h2>
            <p className="text-base text-slate-600 leading-relaxed mb-6">
              Reunimos as perguntas mais comuns sobre nossos serviços, contratos e atendimento. Não encontrou o que procurava? Fale conosco.
            </p>
            <div className="bg-gradient-to-br from-dc-primary to-dc-secondary rounded-2xl p-6 text-white">
              <HelpCircle className="w-7 h-7 text-dc-accent mb-3" strokeWidth={1.5} />
              <h4 className="font-heading font-semibold text-lg mb-1">Tem outra dúvida?</h4>
              <p className="text-blue-100 text-sm">Nossa equipe responde em até 1 hora útil.</p>
            </div>
          </motion.div>

          <div className="lg:col-span-7">
            <Accordion type="single" collapsible className="space-y-3">
              {faqs.map((f, i) => (
                <AccordionItem
                  key={f.id}
                  value={f.id}
                  data-testid={`faq-item-${f.id}`}
                  className="bg-[#f5f7fa] border border-slate-100 rounded-xl px-6 data-[state=open]:bg-white data-[state=open]:border-dc-primary/20 data-[state=open]:shadow-md transition-all"
                >
                  <AccordionTrigger className="text-left text-base font-heading font-semibold text-dc-text hover:no-underline py-5">
                    {f.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-slate-600 leading-relaxed pb-5">
                    {f.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
